import { ThemeUIStyleObject } from "@classdojo/web/nessie/stylingLib";
import * as React from "react";

interface ShadowCardProps {
  className?: string;
  children: React.ReactNode;
  onClick?: VoidFunction;
}

const ShadowCard: React.FC<ShadowCardProps> = ({ children, ...props }) => {
  return (
    <div sx={{ ...cardStyle }} {...props}>
      {children}
    </div>
  );
};

export default ShadowCard;

const cardStyle: ThemeUIStyleObject = {
  borderRadius: "dt_radius_s",
  backgroundColor: "dt_background_primary",
  boxShadow: "dt_shadow_shadezies",
  border: `dt_disabled`,
};
